import WebshopProductSlider from './WebshopProductSlider'

export default WebshopProductSlider
